import { FC, useCallback } from 'react';
import { BreadcrumbStep } from './BreadcrumbStep';
import { BREADCRUMB_KEY, ResourceText } from '../../../types/cms_shared_types';

interface BreadcrumbListProps {
  steps: ResourceText[];
  currentStep: number;
  displayAddonStep: boolean;
}

export const BreadcrumbList: FC<BreadcrumbListProps> = ({ steps, currentStep, displayAddonStep }) => {
  const getDisplayedTotalSteps = useCallback(
    (): number => (displayAddonStep ? steps.length : steps.length - 1),
    [displayAddonStep, steps.length],
  );

  const getDisplayedCurrentStep = useCallback((): number => {
    const addonStepIndex = steps.findIndex((step) => step.key === BREADCRUMB_KEY.ADDONS_STEP);

    if (displayAddonStep || currentStep <= addonStepIndex) {
      return currentStep + 1;
    }

    return currentStep;
  }, [currentStep, displayAddonStep, steps]);

  return (
    <>
      <div className="flex-row hidden lg:flex place-content-center">
        {steps.map((step: ResourceText, index: number) => {
          return (
            <BreadcrumbStep
              key={index}
              name={step.value}
              stepNumber={index}
              selected={currentStep === index}
              hide={!displayAddonStep && step.key === BREADCRUMB_KEY.ADDONS_STEP}
            />
          );
        })}
      </div>

      <div className="flex flex-row justify-center gap-1 text-sm lg:hidden ">
        <div className="font-bold text-sami-green">{steps[currentStep]?.value}</div>
        <div className="text-input-border">{`${getDisplayedCurrentStep()} / ${getDisplayedTotalSteps()}`}</div>
      </div>
    </>
  );
};
